module.exports = __webpack_public_path__ + "img/soft_15.e03ff610.png";